import React from 'react'
import { rem } from 'polished'
import styled from 'styled-components'
import TextButton from 'LuxKit/Button/TextButton'
import Group from 'components/utils/Group'
import Pane from 'components/Common/Pane'
import BodyText from 'LuxKit/Typography/BodyText'
import { useIntl } from 'react-intl'

const CardContent = styled.div`
  padding: ${rem(40)} ${rem(16)};
`

function CruiseSoldoutDepartureCard() {
  const intl = useIntl()

  return <Pane shadow="bottom-small">
    <CardContent>
      <Group direction="vertical" horizontalAlign="center" gap={16}>
        <BodyText variant="large" weight="bold" align="center">
          {intl.formatMessage({
            id: '2U+9c39nu0',
            defaultMessage: 'No departures available',
            description: 'Message shown when no cruise departures are available',
          })}
        </BodyText>
        <TextButton kind="secondary" to="/cruises">
          {intl.formatMessage({
            id: 'QaJorwymgP',
            defaultMessage: 'Browse all cruise offers',
            description: 'Button to navigate to all cruise offers when no departures available',
          })}
        </TextButton>
      </Group>
    </CardContent>
  </Pane>
}

export default CruiseSoldoutDepartureCard
